export type BaseAppConfig = {
  environment: string;
  redirect: string;
  clientUrl: string;
  hostname: string;
  defaultRoute: string;
  baseApi: string;
  theme: "dark-mode" | "light-mode";
  allowThemeChange: boolean;
  allowNewWorkspace: boolean;
};

export default function buildConfig(baseApi: string): BaseAppConfig {
  return {
    environment: "development",
    redirect: "http://localhost:3000/signup",
    clientUrl: "http://localhost:3000",
    hostname: "localhost",
    defaultRoute: "/",
    baseApi,
    theme: "light-mode",
    allowThemeChange: false,
    allowNewWorkspace: true,
    debugMode: true,
  } as BaseAppConfig;
}

export const loadEnvConfig = (key: string) => {
  const value = process.env[key];
  if (!value || value === "") {
    throw new Error(`Missing environment variable: ${key}`);
  }
  return value;
};
